import React from 'react'
import "./Dashboard.css";
const Consutations = () => {
    return (
      <div>
        <div className="dash_title">Scond Look Ortho</div>
        <div className="divtable">
          <table className="table table-striped">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Patient Name</th>
                <th scope="col">State</th>
                <th scope="col">Appointement Type</th>
                <th scope="col">Joint</th>
                <th scope="col">Consultation Date</th>
                <th scope="col">Amount</th>
                <th scope="col">Status</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">1</th>
                <td>Zeeshan Wajid</td>
                <td>California</td>
                <td>Written Report Analysis</td>
                <td>Elbow,</td>
                <td>13 Oct 2020 07:25</td>
                <td>500</td>
                <td>Completed</td>
                <button className="btnview">View</button>
              </tr>

              <tr>
                <th scope="row">2</th>
                <td>Noman</td>
                <td>California</td>
                <td>Video</td>
                <td>shoulder</td>
                <td>13nov 2020 07:25</td>
                <td>500</td>
                <td>New</td>
                <button className="btnview">View</button>
              </tr>
              <tr>
                <th scope="row">3</th>
                <td>Abdullah</td>
                <td>California</td>
                <td>Written Report Analysis</td>
                <td>shoulder</td>
                <td>13nov 2020 07:25</td>
                <td>500</td>
                <td>New</td>
                <button className="btnview">View</button>
              </tr>
             
            </tbody>
          </table>
        </div>
      </div>
    );
}

export default Consutations
